import React from 'react';
import PropTypes from 'prop-types';

import SlideContentContainer from 'src/containers/SlideContentContainer';
import SlideImage from 'src/components/SlideImage';
import 'src/containers/SlideContainer.scss';


const SlideContainer = ({
  isCenterAlign,
  darkFontVersion,
  imgUrl,
  altText,
  title,
  offerCounter,
  isCounterOverButton,
  subtitle,
  buttons
}) => (
  <div data-test="section_slide" styleName="slide">
    <SlideImage
      altText={ altText }
      imgUrl={ imgUrl }
    />
    <SlideContentContainer
      buttons={ buttons }
      darkFontVersion={ darkFontVersion }
      isCenterAlign={ isCenterAlign }
      isCounterOverButton={ isCounterOverButton }
      offerCounter={ offerCounter }
      subtitle={ subtitle }
      title={ title }
    />
  </div>
);

SlideContainer.propTypes = {
  altText: PropTypes.string.isRequired,
  buttons: PropTypes.arrayOf(Object).isRequired,
  darkFontVersion: PropTypes.bool.isRequired,
  imgUrl: PropTypes.arrayOf(PropTypes.shape({
    imgs: PropTypes.arrayOf(Object),
    width: PropTypes.number
  })).isRequired,
  isCenterAlign: PropTypes.bool.isRequired,
  isCounterOverButton: PropTypes.bool.isRequired,
  offerCounter: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default SlideContainer;
